import { EntityType } from '../../definitions/types/Entity';

export const generateWorkspaceUri = (entity: EntityType): string => {
  return `/workspace?entities=${entity.type}:${entity.id}&selected=${entity.type}:${entity.id}`;
};
